import { OutputCarData } from '../../@types';
import { lastDayOfMonth } from 'date-fns';

const defaultCarEntity = {
  id: '',
  status: '',
  brand: '',
  model: '',
  plate: '',
  areaName: '',
  areaId: '',
  position: '',
  fuelLevel: null,
  chassisNumber: '',
  images: [],
  fuelCardNumber: '',
  fuelCardValidUntil: '',
  gear: '',
  enginePower: null,
  pollutionBadge: '',
  initialRegistration: '',
  rentalCount: null,
  fuel: '',
  type: '',
  notes: null,
  equippedSince: null,
  categoryId: '',
  backBy: '',
};

const convertToUTCDate = (date) => {
  const expiryDate = lastDayOfMonth(new Date(date));
  const utcExpiryDate = new Date(
    Date.UTC(
      expiryDate.getFullYear(),
      expiryDate.getMonth(),
      expiryDate.getDate(),
      0,
      0,
      0,
      0
    )
  );
  return utcExpiryDate.toISOString();
};

export const seasonToCar = (car: OutputCarData): any => {
  try {
    return {
      ...defaultCarEntity,
      ...car,
      fuelCardValidUntil: car?.fuelCardValidUntil
        ? convertToUTCDate(car.fuelCardValidUntil)
        : '',
    };
  } catch (e) {
    console.log('exception while processing car ', e);
    return null;
  }
};

const seasonToCars = (cars: OutputCarData[]) => cars?.map(seasonToCar);

export default seasonToCars;
